import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const softwarePlanTeamsRoute: InvariantRoute = {
	name: 'software-plan-teams',
	path: '/jira/plans/:planId/scenarios/:scenarioId/teams',
};
